import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
  user: any;
  error: any;
  loading: boolean;
}

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const slice = createSlice({ name, initialState, reducers });

function createInitialState(): AuthState {
  return {
    user: null,
    error: null,
    loading: false,
  };
}

function createReducers() {
  return {
    setUser,
    logout,
    reset,
  };

  function setUser(state: AuthState, action: any) {
    const { user } = action.payload;
    state.user = user;
  }

  function logout(state: AuthState) {
    state.user = null;
    sessionStorage.clear();
  }

  function reset(state: AuthState) {
    state.error = null;
  }
}

export const authActions = { ...slice.actions };
export const authReducer = slice.reducer;
